var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4998 4.3335L21.6665 8.66683H18.4165L16.2498 4.3335H14.0832L16.2498 8.66683H12.9998L10.8332 4.3335H8.6665L10.8332 8.66683H7.58317L5.4165 4.3335H4.33317C3.1415 4.3335 2.17734 5.3085 2.17734 6.50016L2.1665 19.5002C2.1665 20.6918 3.1415 21.6668 4.33317 21.6668H21.6665C22.8582 21.6668 23.8332 20.6918 23.8332 19.5002V4.3335H19.4998Z",
    fill: "#364452"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/VideoIcon.d375fa1e5de4ac57c2f69718c933cfc1.svg";
export { ForwardRef as ReactComponent };